// Petits utilitaires de dates, sans bibliothèque : jour « pédagogique », semaines ISO.

/** Ajoute des jours à une date AAAA-MM-JJ et renvoie AAAA-MM-JJ. */
export function ajouterJours(date: string, jours: number): string {
  const d = new Date(date + 'T12:00:00Z');
  d.setUTCDate(d.getUTCDate() + jours);
  return d.toISOString().slice(0, 10);
}

/**
 * Le « jour pédagogique » : la journée bascule à 4 h du matin, pas à minuit,
 * pour qu'une session finie à 0 h 30 compte encore pour la veille (R-CAR-03).
 * `quand` est une date locale du navigateur (ou du serveur).
 */
export function jourPedagogique(quand: Date, decalageHeures = 4): string {
  const d = new Date(quand.getTime() - decalageHeures * 3600 * 1000);
  const aaaa = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const jj = String(d.getDate()).padStart(2, '0');
  return `${aaaa}-${mm}-${jj}`;
}

/** Numéro de jour ISO : 1 = lundi … 7 = dimanche. */
export function jourIso(date: string): number {
  const j = new Date(date + 'T12:00:00Z').getUTCDay();
  return j === 0 ? 7 : j;
}

/** Semaine ISO d'une date AAAA-MM-JJ, au format « 2026-W41 » (R-PLA-04). */
export function semaineIso(date: string): string {
  const d = new Date(date + 'T12:00:00Z');
  // Jeudi de la même semaine ISO → son année est l'année ISO.
  const jour = d.getUTCDay() || 7;
  d.setUTCDate(d.getUTCDate() + 4 - jour);
  const debutAnnee = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  const numero = Math.ceil(((d.getTime() - debutAnnee.getTime()) / 86400000 + 1) / 7);
  return `${d.getUTCFullYear()}-W${String(numero).padStart(2, '0')}`;
}

/** Lundi (AAAA-MM-JJ) de la semaine ISO contenant la date. */
export function lundiDe(date: string): string {
  return ajouterJours(date, 1 - jourIso(date));
}

/** Les N semaines ISO consécutives à partir d'une date (lundi de départ). */
export function semainesDepuis(debut: string, nombre: number): string[] {
  const lundi = lundiDe(debut);
  return Array.from({ length: nombre }, (_, i) => semaineIso(ajouterJours(lundi, 7 * i)));
}

/** Formate une date AAAA-MM-JJ en français : « lundi 6 octobre ». */
export function formaterDate(date: string, avecAnnee = false): string {
  const d = new Date(date + 'T12:00:00Z');
  return d.toLocaleDateString('fr-FR', {
    weekday: 'long', day: 'numeric', month: 'long', ...(avecAnnee ? { year: 'numeric' } : {}), timeZone: 'UTC',
  });
}
